import React from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import esLocale from 'date-fns/locale/es';
import DateTimePicker from "@mui/lab/DateTimePicker";
import { TextField } from "@mui/material";
import "./DateTimePicker.css";

const _DateTimePicker = ({ dateValue, setDateValue,label="Fecha",disabled=false }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}locale={esLocale}>
      <DateTimePicker
        renderInput={(props) => <TextField {...props} />}
        label={label}
        value={dateValue}
        locale="es"
        disabled={disabled}
        onChange={(newValue) => {
          setDateValue(newValue);
        }}
      />
    </LocalizationProvider>
  );
};
export default _DateTimePicker;
